/* eslint-disable no-console */

import { register } from "register-service-worker";
import router from "./router";

// Antes la versión nueva quedaba "en espera" hasta que el alumno cerrara TODAS las
// pestañas: un arreglo de front tardaba horas o días en llegarle a quien deja el aula
// abierta (2026-11-02: una pestaña vieja con un loop de 10 POST/s tiró el server).
// Ahora: se busca versión nueva cada hora, se activa apenas se descarga y la página se
// recarga sola, salvo en estas pantallas, donde espera a que el alumno navegue a otra.
const PANTALLAS_SIN_RECARGA = [
  "examen", // rindiendo con tiempo
  "CircuitoPreInscripcion",
  "CircuitoPreInscripcionv2",
  "CircuitoInscripcion",
  "CircuitoPago",
  "InformarPago",
  "Tramite",
  "Consulta",
  "Documento",
  "ContactoBce",
  "ContactoDatos"
];
const UNA_HORA = 60 * 60 * 1000;

function enPantallaProtegida() {
  return PANTALLAS_SIN_RECARGA.includes(router.currentRoute.name);
}

function recargarCuandoSePueda() {
  if (!enPantallaProtegida()) {
    window.location.reload();
    return;
  }
  const dejarDeEsperar = router.afterEach(() => {
    if (!enPantallaProtegida()) {
      dejarDeEsperar();
      window.location.reload();
    }
  });
}

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  // Primera visita: no hay versión anterior que reemplazar, no se recarga nada.
  const habiaVersionAnterior = !!navigator.serviceWorker.controller;
  let recargando = false;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (recargando || !habiaVersionAnterior) return;
    recargando = true;
    recargarCuandoSePueda();
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    registered(registration) {
      // Una SPA abierta horas no navega: sin esto el navegador casi nunca busca versión nueva.
      setInterval(() => registration.update(), UNA_HORA);
    },
    updated(registration) {
      // El service worker generado por Workbox ya escucha este mensaje.
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
